"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskItems = void 0;
var maskItems = {
  '9': /[0-9]/,
  'a': /[A-Za-z]/,
  '*': /[A-Za-z0-9]/
};
exports.maskItems = maskItems;